import dayjs from "dayjs";
import { ITableElement } from "shared/components";
import { formatCurrency } from "shared/utils";
import { columnsContractsType } from "../types/columsContract.types";



export const columnsGridContracts= (): ITableElement<columnsContractsType>[] => {

  const columnsTable = [
    {
        field: 'contract',
        headerName: 'Número de Contrato',
        sortable: 'contract_number',
        minWidth: 170,
        renderCell(params: columnsContractsType) {
          return (<>{params.contract ?? ''}</>)
        },
    },
    {
        field: 'startContractDateService',
        headerName: 'Fecha Inicial de Contrato',
        minWidth: 200,
        renderCell(params: columnsContractsType) {
        return (<>{params.contractStartAt ? dayjs(params.contractStartAt).format('DD MMMM YYYY HH:mm') : ''}</>)
        },
    },

    {
        field: 'endContractDateService',
        headerName: 'Fecha Final de Contrato',
        minWidth: 200,
        renderCell(params: columnsContractsType) {
        return (<>{params.contractEndAt ? dayjs(params.contractEndAt).format('DD MMMM YYYY HH:mm') : ''}</>)
        },
    },
    {
        field: 'valueContract',
        headerName: 'Valor Total Contratado',
        minWidth: 170,
        renderCell(params: columnsContractsType) {
            return (<>{formatCurrency(params?.totalValue ?? 0) }</>)
        },
    },
    {
      field: 'providerNit',
      headerName: 'Nit Contratista',
      minWidth: 130,
      renderCell(params: columnsContractsType) {
        return (<>{ params.providerNit ?? '' }</>)
      },
    },
    {
      field: 'provider',
      headerName: 'Razón social',
      minWidth: 300,
      renderCell(params: columnsContractsType) {
        return (<>{params.providerName ?? ''}</>)
        },
    },
    {
      field: 'cdpNumber',
      headerName: 'CDP del Contrato',
      minWidth: 160,
      renderCell(params: columnsContractsType) {
        return (<>{(params?.cdpNumber ?? '0') }</>)
        },
    },
    {
      field: 'valueAcceptedGloss',
      headerName: 'Saldo Actual Contrato',
      minWidth: 160,
      renderCell(params: columnsContractsType) {
        return (<>{formatCurrency(params?.currentBalance ?? 0)}</>)
      },
    },
  ];
  return columnsTable
} 
    